import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var RefreshIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M23 3c-.6 0-1 .4-1 1v3.7l-2.9-2.8c-.8-.8-2.1-1.8-3.7-2.3-5.3-1.8-11 .8-12.8 6.1-.2.5 0 1.1.6 1.2.5.2 1.1-.1 1.3-.6C6 5.2 10.5 3 14.7 4.5c1 .3 1.9.9 3 1.9L20.5 9H17c-.6 0-1 .4-1 1s.4 1 1 1h6c.1 0 .3 0 .4-.1.1-.1.2-.1.3-.2 0 0 0-.1.1-.1 0-.1.1-.1.1-.2v-.2V4c.1-.6-.3-1-.9-1zm-2.3 11c-.5-.2-1.1.1-1.2.7-.3 1.1-1 2.1-1.9 3-3.1 3.1-8.2 3.1-11.3 0L3.5 15H7c.6 0 1-.4 1-1s-.4-1-1-1H1c-.1 0-.2 0-.3.1H.6s-.1 0-.1.1c-.1 0-.2.1-.2.2 0 0 0 .1-.1.1 0 .1-.1.1-.1.2V20c0 .6.4 1 1 1s1-.4 1-1v-3.7L5 19.1C6.9 21 9.5 22 12.1 22c2.6 0 5.1-1 7.1-2.9 1.1-1.1 1.9-2.4 2.3-3.8 0-.5-.3-1.1-.8-1.3z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
RefreshIcon.isCarinaIcon = true;
export default RefreshIcon;
